import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import IAuthorizationData from "../../../../vendor_core/core/src/server/data/IAuthorizationData";
import GameDataParser from "../../../../vendor_core/src/server/parsers/GameDataParser";

export default class BURGameDataParser extends GameDataParser {
    public check(data: any) {
        return data?.data?.gameData;
    }

    parse(data): IAuthorizationData[] {
        const result = {
            playerConfig: {
                userId: data.data.userId,
                isDemoPlayer: true, // TODO
                currency: "" //TODO MAYBE THERE IS SOME MAPPING
            },
            serverGameConfig: {
                reelToViewMap: data.data.gameData.reelToViewMap,
                paytable: data.data.gameData.payTable,
                layout: data.data.gameData.reelToViewMap, //TODO
                defaultStopPositions: data.data.gameData.reelStops,
                rtp: data.data.gameData.gameRTP,
                scatterReels: GameModel.gameConfig.scatterReels,
                freeSpinSymbol: data.data.gameData.freeSpinSymbol
            }
        };

        return [result];
    }
}
